import { PreviousSelectedProject } from '@/lib/types/global';

export const toPreviousSelectedProject = (data: any): PreviousSelectedProject => {
  return {
    id: data?.id,
    name: data?.name,
  };
};
